/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useContext, useEffect, useMemo, useState } from "react";
import ModalPortal from "components-new/ModalPortal";
import TextArea from "components-new/Textarea";
import { ITableDataModal } from "pages/StepPages/StepFour/One/Tables/models";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import sass from "./assessment.module.sass";
import { useParams } from "react-router-dom";
import GroupCheck from "components-new/GroupCheck";
import InputTemp from "components-new/InputTemp/index";
import { snackWrapper } from "helpers";
import { ChangeActiveTabContext } from "../TableNavigate";
import { ThreatImplementationAssessmentResponse, ViolatorTypeTemplate } from "libs/apiClient/data-contracts";
import { directoryAPI } from "libs/apiClient/Directory";
import { organizationAPI } from "libs/apiClient/Organization";

const initial: ThreatImplementationAssessmentResponse = {
	id: 0,
	type: "",
	accordance: "",
	state: null,
	commentLegal: "",
	commentIndividual: "",
	legal: null,
	individual: null,
	commentState: "",
};

const AssessmentOfObjectivesModal: React.FC<
	ITableDataModal<ThreatImplementationAssessmentResponse> & { options: any[] }
> = ({ toggle, options: optionsType, replace, active, data = [], close }) => {
	const [options, setOptions] = useState<Array<ViolatorTypeTemplate & { id: number }>>([]);
	const { updateTabs } = useContext(ChangeActiveTabContext);

	const [currentObject, setCurrentObject] = useState<ThreatImplementationAssessmentResponse>(initial);

	const params = useParams();

	const changeField = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		setCurrentObject((prevState: any) => {
			return { ...prevState, [name]: value };
		});
	};

	const title = useMemo(() => {
		return `${
			toggle === "edit" ? "Редактирование: " : "Создание: "
		}Оценка целей реализации нарушителями угроз безопасности`;
	}, [toggle]);

	const changeRadio = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setCurrentObject((prevState) => ({ ...prevState, [name]: value !== "0" }));
	};

	useEffect(() => {
		directoryAPI
			.collusionList({ id: +params.threadId!, type: "ESTIMATION" })
			.then(({ data }) => setOptions(data.map((_, index) => ({ id: index + 1, ..._ }))));
		return () => {
			setOptions([]);
			// setCurrentObject(initial)
		};
		//eslint-disable-next-line
	}, [toggle]);

	useEffect(() => {
		if (optionsType[0]) {
			setCurrentObject((prevState) => ({ ...prevState, accordance: optionsType[0].name }));
		}
	}, [optionsType]);

	useEffect(() => {
		if (active) {
			setCurrentObject(active);
		}
	}, [active]);

	const save = () => {
		const { id, ...rest } = currentObject;
		if (toggle === "edit") {
			organizationAPI.objectAssessmentUpdate(id!, rest).then((r) => {
				const response = r.data;
				const newData = [...data]
					.map((_) => (_.id === response.id ? response : _))
					.map((_) => ({ ..._, accordance: r.data.accordance }));
				replace(newData);
				updateTabs("ASSESSMENT");
				snackWrapper("success", "Таблица обновлена");
				close();
			});
		} else if (toggle === "create") {
			organizationAPI.objectAssessmentCreate(+params.threadId!, rest).then((r) => {
				const newData = [...data, r.data].map((_) => ({ ..._, accordance: r.data.accordance }));
				replace(newData);
				updateTabs("ASSESSMENT");
				snackWrapper("success", "Таблица обновлена");
				close();
			});
		}
	};
	const disabled = useMemo(() => {
		return (
			currentObject.individual === null ||
			currentObject.legal === null ||
			currentObject.state === null ||
			!currentObject.type ||
			!currentObject.commentIndividual ||
			!currentObject.commentLegal ||
			!currentObject.accordance
		);
	}, [currentObject]);

	return toggle !== null ? (
		<ModalPortal outSide={false} size={"md"} title={title} handleClose={close}>
			<div className={sass.modal}>
				<InputTemp
					options={options}
					onSelect={(e) => {
						setCurrentObject((prevState) => ({ ...prevState, type: e.type }));
					}}
					name={"type"}
					field={["type"]}
					readOnly={true}
					type={"select"}
					label={"Виды нарушителей"}
					value={currentObject.type}
					placeholder={"Не выбрано"}
					required={true}
				/>
				{/*<TextArea name={'type'}*/}
				{/*          onChange={changeField}*/}
				{/*          value={currentObject.type}*/}
				{/*          placeholder={'Введите текст'}*/}
				{/*          label={'Виды нарушителей'} required={true}/>*/}

				<GroupCheck.Wrapper label={"Нанесение ущерба физическому лицу"} required={true}>
					<GroupCheck.Item
						onChange={changeRadio}
						checked={currentObject.individual !== null && !currentObject.individual}
						value={"0"}
						name={"individual"}
						label={"Неприменимо"}
						type={"radio"}
					/>
					<GroupCheck.Item
						onChange={changeRadio}
						checked={currentObject.individual !== null && currentObject.individual}
						value={"1"}
						name={"individual"}
						label={"Применимо"}
						type={"radio"}
					/>
				</GroupCheck.Wrapper>

				<TextArea
					name={"commentIndividual"}
					onChange={changeField}
					value={currentObject.commentIndividual || ""}
					placeholder={"Введите текст"}
					label={"Комментарий к нанесению ущерба физическому лицу"}
					required={true}
					rows={5}
				/>

				<GroupCheck.Wrapper
					label={"Нанесение ущерба юридическому лицу, индивидуальному предпринимателю"}
					required={true}>
					<GroupCheck.Item
						onChange={changeRadio}
						name={"legal"}
						checked={currentObject.legal !== null && !currentObject.legal}
						value={"0"}
						label={"Неприменимо"}
						type={"radio"}
					/>
					<GroupCheck.Item
						onChange={changeRadio}
						name={"legal"}
						checked={currentObject.legal !== null && currentObject.legal}
						value={"1"}
						label={"Применимо"}
						type={"radio"}
					/>
				</GroupCheck.Wrapper>

				<TextArea
					name={"commentLegal"}
					onChange={changeField}
					value={currentObject.commentLegal || ""}
					placeholder={"Введите комментарий"}
					label={"Комментарий к нанесению ущерба юридическому лицу, индивидуальному предпринимателю"}
					required={true}
					rows={5}
				/>

				<GroupCheck.Wrapper
					label={
						"Нанесение ущерба государству в области обеспечения обороны страны, безопасности государства и правопорядка, \n" +
						"а также в социальной, экономической, политической, экологической сферах деятельности"
					}
					required={true}>
					<GroupCheck.Item
						onChange={changeRadio}
						name={"state"}
						checked={currentObject.state !== null && !currentObject.state}
						value={"0"}
						label={"Неприменимо"}
						type={"radio"}
					/>
					<GroupCheck.Item
						onChange={changeRadio}
						name={"state"}
						checked={currentObject.state !== null && currentObject.state}
						value={"1"}
						label={"Применимо"}
						type={"radio"}
					/>
				</GroupCheck.Wrapper>
				<TextArea
					name={"commentState"}
					onChange={changeField}
					value={currentObject.commentState || ""}
					placeholder={"Введите комментарий"}
					label={"Комментарий к нанесение ущерба государству"}
					rows={5}
				/>

				<TextArea
					name={"accordance"}
					onChange={changeField}
					value={currentObject.accordance || ""}
					placeholder={"Введите комментарий"}
					label={"Соответствие целей видам риска (ущерба) и возможным негативным последствиям"}
					required={true}
					rows={8}
				/>

				<div className={sass.btn}>
					<Button onClick={close} variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button disabled={disabled} onClick={save} variant={BUTTON_VARIANTS.CONTAINED}>
						Сохранить
					</Button>
				</div>
			</div>
		</ModalPortal>
	) : null;
};

export default AssessmentOfObjectivesModal;
